'use client'
import { axiosAdmin } from '@/lib/axios'
import { useAuthStore } from '@/store/AuthStore'
import { useQuery } from '@tanstack/react-query'

export function useGetCartItems() {
	const accessToken = useAuthStore((state) => state.accessToken);
	return useQuery({
		queryKey: ['getcart'],
		queryFn: async () => {
			try {
				const response = await axiosAdmin.get('/user/cart')
				return response?.data
			} catch (error) {
				console.log('err', error)
				throw error
			}
		},
		enabled: Boolean(accessToken), // Reactive: updates when user logs in/out
	})
}

export function useGetAllAddresses() {
	const accessToken = useAuthStore((state) => state.accessToken);
	return useQuery({
		queryKey: ['getAddresses'],
		queryFn: async () => {
			try {
				const response = await axiosAdmin.get('/user/addresses')
				console.log(response?.data)
				return response?.data
			} catch (error) {
				console.log('err', error)
				throw error
			}
		},
		enabled: Boolean(accessToken), // Reactive: updates when user logs in/out
	})
}
